const blogList = (() => {

    const initBlock = (el) => {
        intersectionObserver(el);
        handleFilters(el);
    };

    const intersectionObserver = (el) => {
        const inViewport = (entries, observer) => {
            entries.forEach((entry) => {
                entry.target.setAttribute('data-spinner-in-view', entry.isIntersecting);
                if (entry.isIntersecting) {
                    const blogs = el.querySelector('.blog-list__blogs');
                    if (blogs){
                        handleGetBlogs(el, blogs);
                    }
                }
            });
        };
        const Obs = new IntersectionObserver(inViewport);
        const obsOptions = {};
        const ELs_inViewport = document.querySelectorAll('[data-spinner-in-view]');
        ELs_inViewport.forEach(el => {
            Obs.observe(el, obsOptions);
        });
    }

    const handleGetBlogs = (el, blogs) => {
        const blogPageId = blogs.dataset.blogPageId;
        const blogsLoaded = blogs.dataset.blogsLoaded;
        const blogsTotal = blogs.dataset.blogsTotal;
        const blogsCategory = blogs.dataset.category;
        const url = `/umbraco/surface/Blog/GetBlogs?id=${blogPageId}&loaded=${blogsLoaded}&category=${blogsCategory}`;
        fetch(url)
            .then(response => response.text())
            .then(data => {
                const newElement = blogs.querySelector('.blog-list__blogs__new');
                newElement.outerHTML = data;
                let blogsLoadedVal = parseInt(blogsLoaded);
                blogsLoadedVal = blogsLoadedVal + 6;
                blogs.dataset.blogsLoaded = blogsLoadedVal;
                const updatedBlogsLoaded = blogs.dataset.blogsLoaded;
                if (parseInt(updatedBlogsLoaded) >= parseInt(blogsTotal)){
                    const spinner = el.querySelector('.spinner');
                    if (spinner){
                        spinner.classList.add('spinner--hidden');
                    }
                }
            });
    }

    const handleFilters = (el) => {
        const spinner = el.querySelector('.spinner');
        const blogs = el.querySelector('.blog-list__blogs');
        const filters = el.querySelector('.blog-list__filter__select__label');
        const options = el.querySelector('.blog-list__filter__select__options');
        if (filters){
            filters.addEventListener('click', () => {
                options.classList.toggle('blog-list__filter__select__options--open');
            });
            const options = el.querySelector('.blog-list__filter__select__options');
            options.querySelectorAll('.blog-list__filter__select__options__option').forEach(option => {
                const optionValue = option.dataset.value;
                option.addEventListener('click', () => {
                    spinner.classList.remove('spinner--hidden');
                    const filtersText = filters.querySelector('.blog-list__filter__select__label__text');
                    filtersText.innerHTML = optionValue;
                    options.classList.remove('blog-list__filter__select__options--open');
                    blogs.innerHTML = `<div class="blog-list__blogs__new"></div>`;
                    blogs.dataset.category = optionValue;
                    blogs.dataset.blogsLoaded = "0";
                    blogs.dataset.blogsTotal = option.dataset.count;
                });
            });
        }
    }

    return {initBlock};
})();

ControlBinders.register('.blog-list', el => blogList.initBlock(el));